<template>
  <div id="CpapFollowUpCallList">
    <div id="container">
      <NaviBar v-bind:pageid="'CpapFollowUpCallList'" />
      <div class="labelTitle lable">コール管理</div>
      <!-- 検索条件入力エリア -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>患者<br />コード</th>
            <td>
              <input type="text" v-model="searchConditions.patientCode" />
            </td>
            <th class="td-blank"></th>
            <td class="td-blank"></td>
            <th class="td-blank"></th>
            <td class="td-blank"></td>
            <th class="td-blank"></th>
            <td class="td-blank"></td>
          </tr>
          <tr>
            <th>コール<br />種別</th>
            <td>
              <select v-model="searchConditions.callType">
                <option :value="0"></option>
                <option
                  v-for="item in callTypeList"
                  :key="item.code"
                  :value="item.code"
                >{{ item.name }}</option>
              </select>
            </td>
            <th>コール状況</th>
            <td>
              <select v-model="searchConditions.callStatus">
                <option :value="0"></option>
                <option
                  v-for="item in callStatusList"
                  :key="item.code"
                  :value="item.code"
                >{{ item.name }}</option>
                <option :value="-3">完了以外</option>
              </select>
            </td>
            <th>エスカレーション状況</th>
            <td>
              <select v-model="searchConditions.escalationStatus">
                <option :value="0"></option>
                <option
                  v-for="item in callEscalationStatusList"
                  :key="item.code"
                  :value="item.code"
                >{{ item.name }}</option>
              </select>
            </td>
            <th class="td-blank"></th>
            <td class="td-blank"></td>
          </tr>
          <tr>
            <th>ブロック</th>
            <td>
              <select v-model="searchConditions.blockCode">
                <option value=""></option>
                <option
                  v-for="item in areaBlockList"
                  :key="item.code"
                  :value="item.code"
                >{{ item.name }}</option>
              </select>
            </td>
            <th>担当支店</th>
            <td>
              <select v-model="searchConditions.branchOfficeCode">
                <option value=""></option>
                <option
                  v-for="item in branchOfficeList"
                  :key="item.code"
                  :value="item.code"
                >{{ item.name }}</option>
              </select>
            </td>
            <th class="td-blank"><br/><br/></th>
            <td class="td-blank"></td>
            <th class="td-blank"></th>
            <td class="td-blank"></td>
          </tr>
          <tr>
            <th>架電<br />予定日</th>
            <td colspan="3">
              <input
                type="date"
                style="width: 200px"
                v-model="searchConditions.callScheduledDateStart"
              />
              &nbsp;～&nbsp;
              <input
                type="date"
                style="width: 200px"
                v-model="searchConditions.callScheduledDateEnd"
              />
            </td>
            <th>架電日</th>
            <td colspan="3">
              <input
                type="date"
                style="width: 200px"
                v-model="searchConditions.callImplementationDateStart"
              />
              &nbsp;～&nbsp;
              <input
                type="date"
                style="width: 200px"
                v-model="searchConditions.callImplementationDateEnd"
              />
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="search">検索</b-button>
        </div>
      </div>
      <!-- 検索結果表示エリア -->
      <div class="result-area" v-show="isShowResultArea">
        <div class="result-data" v-if="tableData.length > 0">
          <div class="result-button-area">
            <b-button
              style="margin-right: 10px"
              class="clipboadCopyButton is-primary"
              @click="clipboardCopy()"
            >クリップボードにコピー</b-button
            >
            <b-button
              class="is-primary"
              :icon-left="isShowColumnSelectBox ? 'close-box-outline' : 'table-column-width'"
              @click="isShowColumnSelectBox = !isShowColumnSelectBox"
            >{{ isShowColumnSelectBox ? "閉じる" : "列選択" }}</b-button>
          </div>
          <!-- 列表示／非表示選択表 -->
          <div v-show="isShowColumnSelectBox">
            <div class="column-select-box">
              <div>
                <b-checkbox
                  class="table-column-checkbox"
                  v-model="isAllColumnSelected"
                  @input="selectAllCheckBox"
                  >全てチェック</b-checkbox
                >
                <label @click="isShowColumnSelectBox = false" class="close-icon">
                  <b-icon icon="close" @click="isShowColumnSelectBox = false"/>
                </label>
              </div>
              <div>
                <template v-for="column in tableColumns">
                  <b-checkbox
                    v-model="column.isVisible"
                    class="table-column-checkbox"
                    :key="column.title"
                    @input="adjustTableWidth"
                  >{{ column.label }}</b-checkbox>
                </template>
              </div>
            </div>
          </div>
          <!-- 検索結果一覧表 -->
          <div>
            <b-table
              id="call-list-table"
              :data="tableData"
              :paginated="isPaginated"
              per-page="50"
              pagination-position="both"
              default-sort="callId"
            >
              <template slot-scope="props">
                <b-table-column
                  field="callId"
                  :label="tableColumns['callId'].label"
                  :visible="tableColumns['callId'].isVisible"
                  :width="tableColumns['callId'].width"
                  centered
                  sortable
                >
                  <router-link
                    :to="{
                      name: 'CpapFollowUpCallDetail',
                      params: {
                        searchConditions: searchConditions,
                        callId: props.row.callId,
                        callSearchFlag: true,
                      },
                    }"
                  >{{ props.row.callId }}</router-link>
                </b-table-column>
                <b-table-column
                  field="callStaffName"
                  :label="tableColumns['callStaffName'].label"
                  :visible="tableColumns['callStaffName'].isVisible"
                  :width="tableColumns['callStaffName'].width"
                  sortable
                >{{ props.row.callStaffName }}</b-table-column>
                <b-table-column
                  field="patientCode"
                  :label="tableColumns['patientCode'].label"
                  :visible="tableColumns['patientCode'].isVisible"
                  :width="tableColumns['patientCode'].width"
                  sortable
                >{{ convertDisplayByDeviceType(props.row.patientCode, props.row.deviceTypeCode) }}</b-table-column>
                <b-table-column
                  field="patientName"
                  :label="tableColumns['patientName'].label"
                  :visible="tableColumns['patientName'].isVisible"
                  :width="tableColumns['patientName'].width"
                  sortable
                >{{ props.row.patientName }}</b-table-column>
                <b-table-column
                  field="patientNameKana"
                  :label="tableColumns['patientNameKana'].label"
                  :visible="tableColumns['patientNameKana'].isVisible"
                  :width="tableColumns['patientNameKana'].width"
                  sortable
                >{{ props.row.patientNameKana }}</b-table-column>
                <b-table-column
                  field="patientMobilePhoneNumber"
                  :label="tableColumns['patientMobilePhoneNumber'].label"
                  :visible="tableColumns['patientMobilePhoneNumber'].isVisible"
                  :width="tableColumns['patientMobilePhoneNumber'].width"
                  sortable
                >{{ convertDisplayByDeviceType(props.row.patientMobilePhoneNumber, props.row.deviceTypeCode) }}</b-table-column>
                <b-table-column
                  field="patientPhoneNumber"
                  :label="tableColumns['patientPhoneNumber'].label"
                  :visible="tableColumns['patientPhoneNumber'].isVisible"
                  :width="tableColumns['patientPhoneNumber'].width"
                  sortable
                >{{ props.row.patientPhoneNumber }}</b-table-column>
                <b-table-column
                  field="chargeBranchName"
                  :label="tableColumns['chargeBranchName'].label"
                  :visible="tableColumns['chargeBranchName'].isVisible"
                  :width="tableColumns['chargeBranchName'].width"
                  sortable
                >{{ props.row.chargeBranchName }}</b-table-column>
                <b-table-column
                  field="medicalInstitutionCode"
                  :label="tableColumns['medicalInstitutionCode'].label"
                  :visible="tableColumns['medicalInstitutionCode'].isVisible"
                  :width="tableColumns['medicalInstitutionCode'].width"
                  sortable
                >{{ props.row.medicalInstitutionCode }}</b-table-column>
                <b-table-column
                  field="medicalInstitutionName"
                  :label="tableColumns['medicalInstitutionName'].label"
                  :visible="tableColumns['medicalInstitutionName'].isVisible"
                  :width="tableColumns['medicalInstitutionName'].width"
                  sortable
                >{{ props.row.medicalInstitutionName }}</b-table-column>
                <b-table-column
                  field="deviceItemCode"
                  :label="tableColumns['deviceItemCode'].label"
                  :visible="tableColumns['deviceItemCode'].isVisible"
                  :width="tableColumns['deviceItemCode'].width"
                  sortable
                >{{ convertDeviceModelName(props.row.deviceTypeCode, props.row.deviceItemCode, props.row.inspectionDeviceId) }}</b-table-column>
                <b-table-column
                  field="deviceSerial"
                  :label="tableColumns['deviceSerial'].label"
                  :visible="tableColumns['deviceSerial'].isVisible"
                  :width="tableColumns['deviceSerial'].width"
                  sortable
                >{{ props.row.deviceSerial }}</b-table-column>
                <b-table-column
                  field="isDeviceReturned"
                  :label="tableColumns['isDeviceReturned'].label"
                  :visible="tableColumns['isDeviceReturned'].isVisible"
                  :width="tableColumns['isDeviceReturned'].width"
                  sortable
                >{{ convertDeviceReturnStatus(props.row.isDeviceReturned, props.row.deviceSerial) }}</b-table-column>
                <b-table-column
                  field="humidifierItemCode"
                  :label="tableColumns['humidifierItemCode'].label"
                  :visible="tableColumns['humidifierItemCode'].isVisible"
                  :width="tableColumns['humidifierItemCode'].width"
                  sortable
                >{{ convertDisplayByDeviceType(props.row.humidifierItemCode, props.row.deviceTypeCode) }}</b-table-column>
                <b-table-column
                  field="humidifierSerial"
                  :label="tableColumns['humidifierSerial'].label"
                  :visible="tableColumns['humidifierSerial'].isVisible"
                  :width="tableColumns['humidifierSerial'].width"
                  sortable
                >{{ convertDisplayByDeviceType(props.row.humidifierSerial, props.row.deviceTypeCode) }}</b-table-column>
                <b-table-column
                  field="isHumidifierReturned"
                  :label="tableColumns['isHumidifierReturned'].label"
                  :visible="tableColumns['isHumidifierReturned'].isVisible"
                  :width="tableColumns['isHumidifierReturned'].width"
                  sortable
                >{{ convertDisplayByDeviceType(
                      convertDeviceReturnStatus(props.row.isHumidifierReturned, props.row.humidifierSerial),
                      props.row.deviceTypeCode
                    )
                  }}</b-table-column>
                <b-table-column
                  field="cpapBillingTargetCode"
                  :label="tableColumns['cpapBillingTargetCode'].label"
                  :visible="tableColumns['cpapBillingTargetCode'].isVisible"
                  :width="tableColumns['cpapBillingTargetCode'].width"
                  sortable
                >{{ convertDisplayByDeviceType(props.row.cpapBillingTargetCode, props.row.deviceTypeCode) }}</b-table-column>
                <b-table-column
                  field="cpapBillingTargetName"
                  :label="tableColumns['cpapBillingTargetName'].label"
                  :visible="tableColumns['cpapBillingTargetName'].isVisible"
                  :width="tableColumns['cpapBillingTargetName'].width"
                  sortable
                >{{ convertDisplayByDeviceType(props.row.cpapBillingTargetName, props.row.deviceTypeCode) }}</b-table-column>
                <b-table-column
                  field="callType"
                  :label="tableColumns['callType'].label"
                  :visible="tableColumns['callType'].isVisible"
                  :width="tableColumns['callType'].width"
                  sortable
                >{{ convertCallType(props.row.callType) }}</b-table-column>
                <b-table-column
                  field="callStatus"
                  :label="tableColumns['callStatus'].label"
                  :visible="tableColumns['callStatus'].isVisible"
                  :width="tableColumns['callStatus'].width"
                  sortable
                >{{ convertCallStatus(props.row.callStatus) }}</b-table-column>
                <b-table-column
                  field="callScheduledDate"
                  :label="tableColumns['callScheduledDate'].label"
                  :visible="tableColumns['callScheduledDate'].isVisible"
                  :width="tableColumns['callScheduledDate'].width"
                  sortable
                >{{ props.row.callScheduledDate }}</b-table-column>
                <b-table-column
                  field="callImplementationDate"
                  :label="tableColumns['callImplementationDate'].label"
                  :visible="tableColumns['callImplementationDate'].isVisible"
                  :width="tableColumns['callImplementationDate'].width"
                  sortable
                >{{ props.row.callImplementationDate }}</b-table-column>
                <b-table-column
                  field="hearingDetail"
                  class="detail-content"
                  :label="tableColumns['hearingDetail'].label"
                  :visible="tableColumns['hearingDetail'].isVisible"
                  :width="tableColumns['hearingDetail'].width"
                  sortable
                >
                  <span>{{ props.row.hearing1 }}</span>
                  <span>{{ props.row.hearing2 }}</span>
                  <span>{{ props.row.hearing3 }}</span>
                  <span>{{ props.row.hearing4 }}</span>
                </b-table-column>
                <b-table-column
                  field="escalationStatus"
                  :label="tableColumns['escalationStatus'].label"
                  :visible="tableColumns['escalationStatus'].isVisible"
                  :width="tableColumns['escalationStatus'].width"
                  sortable
                >{{ convertEscalationDisplay(
                      convertEscalationStatus(props.row.escalationStatus),
                      props.row.callId
                    )
                  }}</b-table-column>
                <b-table-column
                  field="escalationType"
                  :label="tableColumns['escalationType'].label"
                  :visible="tableColumns['escalationType'].isVisible"
                  :width="tableColumns['escalationType'].width"
                  sortable
                >{{ convertEscalationDisplay(
                      convertEscalationType(props.row.escalationType),
                      props.row.callId
                    )
                  }}</b-table-column>
                <b-table-column
                  class="detail-content"
                  field="escalationDetail"
                  :label="tableColumns['escalationDetail'].label"
                  :visible="tableColumns['escalationDetail'].isVisible"
                  :width="tableColumns['escalationDetail'].width"
                  sortable
                >{{ convertEscalationDisplay(props.row.escalationDetail, props.row.callId) }}</b-table-column>
              </template>
            </b-table>
          </div>
        </div>
        <div class="no-data" v-else>
          該当データは存在しません
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  cpapCallTypeList,
  cpapCallStatusList,
  escalationTypeList,
  cpapCallEscalationStatusList,
} from "@/components/mock/base/const.js";
import NaviBar from "@/components/mock/philips/device/DeviceNaviBar";

export default {
  name: "CpapFollowUpCallList",
  data() {
    return {
      callTypeList: cpapCallTypeList,
      callStatusList: cpapCallStatusList,
      escalationTypeList,
      callEscalationStatusList: cpapCallEscalationStatusList,
      cpapModelList: this.getCpapMaster(),
      branchOfficeList: this.getBranchOfficeMaster(),
      areaBlockList: this.getBlockMaster(),
      inspectionDeviceList: [],
      searchConditions: {
        patientCode: "",
        callType: 0,
        callStatus: 0,
        escalationStatus: 0,
        blockCode: "",
        branchOfficeCode: "",
        callScheduledDateStart: "",
        callScheduledDateEnd: "",
        callImplementationDateStart: "",
        callImplementationDateEnd: "",
      },
      tableColumns: {
        callId: { label: "コールID", width: 150, isVisible: true, name: "callId" },
        callStaffName: { label: "コール実施者名", width: 200, isVisible: true, name: "callStaffName" },
        patientCode: { label: "患者コード", width: 150, isVisible: true, name: "patientCode" },
        patientName: { label: "患者名", width: 200, isVisible: true, name: "patientName" },
        patientNameKana: { label: "患者名（カナ）", width: 200, isVisible: true, name: "patientNameKana" },
        patientMobilePhoneNumber: { label: "連絡先（携帯電話）", width: 200, isVisible: true, name: "patientMobilePhoneNumber" },
        patientPhoneNumber: { label: "連絡（自宅・その他）", width: 200, isVisible: true, name: "patientPhoneNumber" },
        chargeBranchName: { label: "担当支店", width: 130, isVisible: true, name: "chargeBranchName" },
        medicalInstitutionCode: { label: "病院コード", width: 150, isVisible: true, name: "medicalInstitutionCode" },
        medicalInstitutionName: { label: "医療機関名", width: 200, isVisible: true, name: "medicalInstitutionName" },
        deviceItemCode: { label: "該当機器名", width: 200, isVisible: true, name: "deviceItemCode" },
        deviceSerial: { label: "該当機器シリアル", width: 200, isVisible: true, name: "deviceSerial" },
        isDeviceReturned: { label: "機器返却状況", width: 150, isVisible: true, name: "isDeviceReturned" },
        humidifierItemCode: { label: "加湿器名", width: 200, isVisible: true, name: "humidifierItemCode" },
        humidifierSerial: { label: "加湿器シリアル", width: 200, isVisible: true, name: "humidifierSerial" },
        isHumidifierReturned: { label: "加湿器返却状況", width: 150, isVisible: true, name: "isHumidifierReturned" },
        cpapBillingTargetCode: { label: "請求先コード", width: 150, isVisible: true, name: "cpapBillingTargetCode" },
        cpapBillingTargetName: { label: "請求先名", width: 200, isVisible: true, name: "cpapBillingTargetName" },
        callType: { label: "コール種別", width: 200, isVisible: true, name: "callType" },
        callStatus: { label: "コール状況", width: 150, isVisible: true, name: "callStatus" },
        callScheduledDate: { label: "架電予定日", width: 150, isVisible: true, name: "callScheduledDate" },
        callImplementationDate: { label: "架電実施日", width: 150, isVisible: true, name: "callImplementationDate" },
        hearingDetail: { label: "ヒアリング内容", width: 200, isVisible: true, name: "hearingDetail" },
        escalationStatus: { label: "エスカレーション状況", width: 200, isVisible: true, name: "escalationStatus" },
        escalationType: { label: "エスカレーション種別", width: 200, isVisible: true, name: "escalationType" },
        escalationDetail: { label: "エスカレーション有無", width: 200, isVisible: true, name: "escalationDetail" },
      },
      tableData: [],
      isShowResultArea: false,
      isPaginated: true,
      isShowColumnSelectBox: false,
      isAllColumnSelected: false,
    };
  },
  methods: {
    async search() {
      let isSearchParam = false;
      let keys = Object.keys(this.searchConditions);
      for (let i = 0; i < keys.length; i++) {
        if (this.searchConditions[keys[i]] != "" || this.searchConditions[keys[i]] != 0) {
          isSearchParam = true;
          break;
        }
      }
      if (!isSearchParam) {
        this.showErrorMessage("検索条件が入力されていません。");
        return;
      }
      let requestApi = this.findCallListApi;
      let successCallBack = this.findCallListSuccess;
      let errorCallBack = this.findCallListError;
      await this.apiCall(requestApi, successCallBack, errorCallBack);
      this.adjustTableWidth();
    },
    findCallListApi(client) {
      return client.apis.internalCpap.getCpapCallListPOST({
        body: this.searchConditions,
      });
    },
    findCallListSuccess(result) {
      this.tableData = result.obj;
      this.isShowResultArea = true;
    },
    findCallListError(result) {
      this.showErrorMessage(result);
    },

    findInspectionDevices() {
      let requestApi = this.findInspectionDevicesApi;
      let successCallBack = this.findInspectionDevicesSuccess;
      let errorCallBack = this.findInspectionDevicesError;
      this.apiCall(requestApi, successCallBack, errorCallBack);
    },
    findInspectionDevicesApi(client) {
      return client.apis.internalDeviceManagement.getDeviceKindsPOST({
        body: {}
      });
    },
    findInspectionDevicesSuccess(result) {
      this.inspectionDeviceList = result.obj;
    },
    findInspectionDevicesError(error) {
      // this.showErrorMessage(error);
    },

    selectAllCheckBox() {
      Object.values(this.tableColumns).map(
        col => (col.isVisible = this.isAllColumnSelected)
      );
      this.adjustTableWidth();
    },
    adjustTableWidth() {
      let tableWidth = 0;
      let table = document.getElementById("call-list-table").getElementsByTagName("table")[0];
      Object.values(this.tableColumns).forEach(val => {
        if(val.isVisible) {
          tableWidth += val.width;
        }
      });
      table.style.width = `${tableWidth}px`;
    },

    convertDisplayByDeviceType(val, deviceTypeCode) {
      let text = "";
      if(deviceTypeCode == "CPAP") {
        text = val;
      } else {
        text = "ー";
      }
      return text;
    },
    convertEscalationDisplay(val, callId) {
      let text = "なし";
      if(val) {
        text = val;
      }
      if(callId && callId.startsWith("D")) {
        text = "ー";
      }
      return text;
    },
    convertEscalationStatus(status) {
      let text = "";
      let finding = this.callEscalationStatusList.find(item => item.code == status);
      if (finding) {
        text = finding.name;
      }
      return text;
    },
    convertDeviceModelName(deviceTypeCode, cpapDeviceCode, inspectionDeviceId) {
      let text = "";
      let device = null;
      switch (deviceTypeCode) {
        case "CPAP":
          device = this.cpapModelList.find(item => item.itemCodes.indexOf(cpapDeviceCode) != -1);
          text = device ? device.itemName : "";
          break;
        case "HST":
        case "CORP":
        case "HOLTER":
          device = this.inspectionDeviceList.find(item => item.value == inspectionDeviceId);
          text = device ? device.kind : "";
        default:
          break;
      }
      return text;
    },
    convertDeviceReturnStatus(status, serial) {
      let text = "ー";
      if (serial) {
        text = status ? "返却済み" : "未返却";
      }
      return text;
    },
    convertCallType(status) {
      let text = "";
      let finding = this.callTypeList.find(item => item.code == status);
      if (finding) {
        text = finding.name;
      }
      return text;
    },
    convertCallStatus(status) {
      let text = "";
      let finding = this.callStatusList.find(item => item.code == status);
      if (finding) {
        text = finding.name;
      }
      return text;
    },
    convertEscalationType(status) {
      let text = "";
      let finding = this.escalationTypeList.find(item => item.code == status);
      if (finding) {
        text = finding.name;
      }
      return text;
    },

    clipboardCopy() {
      let copyPasteText = "";

      let headerTextList = [];
      Object.values(this.tableColumns).forEach((val) => {
        headerTextList.push(val.label);
      });
      copyPasteText = headerTextList.join("\t");
      copyPasteText += "\n";
      for(let data of this.tableData) {
        let callId = data.callId;
        let deviceTypeCode = data.deviceTypeCode;

        let dataTextList = [];
        Object.values(this.tableColumns).forEach((val) => {
          let content = "";
          switch(val.name) {
            case "patientCode":
            case "patientMobilePhoneNumber":
            case "humidifierItemCode":
            case "humidifierSerial":
            case "cpapBillingTargetCode":
            case "cpapBillingTargetName":
              content = this.convertDisplayByDeviceType(data[val.name], deviceTypeCode);
              break;
            case "deviceItemCode":
              content = this.convertDeviceModelName(deviceTypeCode, data[val.name], data["inspectionDeviceId"]);
              break;
            case "isDeviceReturned":
              content = this.convertDeviceReturnStatus(data[val.name], data["deviceSerial"]);
              break;
            case "isHumidifierReturned":
              content = this.convertDisplayByDeviceType(
                this.convertDeviceReturnStatus(data[val.name], data["humidifierSerial"]),
                deviceTypeCode
              );
              break;
            case "callType":
              content = this.convertCallType(data[val.name]);
              break;
            case "callStatus":
              content = this.convertCallStatus(data[val.name]);
              break;
            case "hearingDetail":
              content = convertEmptyOr(data.hearing1) + "\n"
              + convertEmptyOr(data.hearing2) + "\n"
              + convertEmptyOr(data.hearing3) + "\n"
              + convertEmptyOr(data.hearing4);
              break;
            case "escalationStatus":
              content = this.convertEscalationDisplay(this.convertEscalationStatus(data[val.name]), callId);
              break;
            case "escalationType":
              content = this.convertEscalationDisplay(this.convertEscalationType(data[val.name]), callId)
              break;
            case "escalationDetail":
              content = this.convertEscalationDisplay(data[val.name], callId)
              break;
            default:
              content = data[val.name];
              content = content ? String(content) : "";
              break;
          }
          content = content ? content.replace(/\r?\n/g, " ") : "";
          dataTextList.push(content);
        });
        copyPasteText += dataTextList.join("\t");
        copyPasteText += "\n";
      }

      function convertEmptyOr(val) {
        return val ? val : "";
      }

      navigator.clipboard
        .writeText(copyPasteText)
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(() => {
          this.showMessage("コピーに失敗しました");
        });
    },
  },
  components: {
    NaviBar,
  },
  created() {
    this.findInspectionDevices();
  },
  mounted() {
    let takeOverSearchParams = this.$route.params["searchConditions"];
    if(takeOverSearchParams) {
      this.searchConditions = takeOverSearchParams;
      this.search();
    }
  },
};
</script>

<style scoped>
.conditionTable th {
  width: 120px;
}
.conditionTable td {
  width: 400px;
}
.result-button-area {
  display: flex;
}
.column-select-box {
  position: absolute;
  background: #ffffff;
  width: 800px;
  padding: 1.5em;
  border-radius: 6px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  z-index: 10;
}
.column-select-box > * {
  text-align: left;
}
.table-column-checkbox {
  width: auto !important;
  margin: 0 !important;
}
.close-icon {
  border: 1px solid #cccccc;
  border-radius: 6px;
  float: right;
}
.detail-content {
  max-width: 250px;
  overflow-wrap: break-word;
}
</style>
<style>
#call-list-table .table-wrapper {
  overflow: auto;
  width: 120%;
  max-height: 700px;
}
#call-list-table table th {
  position: sticky;
  top: 0;
  background: #ffffff;
  font-size: 14px;
}
#call-list-table table td {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
}
.no-data {
  margin-top: 3em;
  padding: 1em;
  border: 1px solid #cccccc;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/call/CpapFollowUpCallList.vue